import { ScheduledMessageFormKey } from '@asset/enum/chatEnum';
export let GroupChannelCustomType = /*#__PURE__*/function (GroupChannelCustomType) {
  GroupChannelCustomType["IN_CLASS"] = "IN_CLASS";
  GroupChannelCustomType["AT_HOME"] = "AT_HOME";
  return GroupChannelCustomType;
}({});